module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "permitsduetable",
    attrs: {
      "table-ref": "permitsduetable",
      "title": "Permits Due Report",
      "icon": "fa fa-list",
      "url": "/permits",
      "fields": _vm.fields,
      "sort-field": "expiry",
      "detail-component": "permits-detail-row"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "permits"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d46b5cea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/permits/PermitsDueReport.vue
// module id = 1715
// module chunks = 0